import React, { Component } from "react";
import "../index.css";
import styled from "styled-components";
import MuiWrapper from "../MuiWrapper";
import AppConfig from "../Config";
import Delighters from "../Components/ReactDelighters";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet";
import WelcomeDialog from "../Components/WelcomeDialog";
import { ScrollPercentage } from "react-scroll-percentage";
import GA from "../Utils/GA";

class Layout extends Component {
  constructor(props) {
    super(props);
    this._lastScrollPosition = -1;
    this._lastPathname = "";
  }

  componentDidMount() {
    window.addEventListener("scroll", this._onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this._onScroll);
  }

  render() {
    let {
      location: { pathname }
    } = this.props;
    let passBreakpoint = !!this.passBreakpoint;
    pathname = this._normalizePath(pathname);

    // FIXME : this should not be in he
    this._dirtyHackForPathMonitor();

    let withPaddingTop = !AppConfig.global.navbarCoverContent;

    if (pathname === "/") {
      withPaddingTop = false;
    }

    return (
      <Delighters>
        <MuiWrapper>
          <Layout.Wrapper withPaddingTop={withPaddingTop}>
            <Helmet>
              <title>HECAFE 好咖嚴選</title>
              <meta name="facebook-domain-verification" content="2looawnsq6qgc9velnts6ija08193l" />
              <meta
                name="description"
                content="找好咖啡，就上好咖嚴選 - 最懂您的咖啡線上平台"
              />
              {/*<!-- site verification for: https://hecafe.com.tw/ ---> */}       
              <meta name="google-site-verification" content="tDbGfN1sS9iVLTxFU9470mEp4pTRSFwjylxNnnOei5c" />
              <link rel="shortcut icon" href="/images/logo.png" />
              <script src="/font.js" />
            </Helmet>

            <Navbar
              isNavbarTransparent={
                this._isNavbarTransparentInPage() && !this.passBreakpoint
              }
              passBreakpoint={passBreakpoint || withPaddingTop}
              pathname={pathname}
            />

            <ScrollPercentage
              as="div"
              onChange={(percentage, entry) =>
                this._sendGAScrollTrackingIfNeed(percentage)
              }
            >
              <Layout.Content>{this.props.children}</Layout.Content>
            </ScrollPercentage>
            <WelcomeDialog />
            <Footer
              isFooterDisplayNone={this._isFooterDisplayNoneInPage()}
              pathname={pathname}
            />
          </Layout.Wrapper>
        </MuiWrapper>
      </Delighters>
    );
  }

  _normalizePath = path => {
    if (path.slice(0, 2) === "//") {
      path = path.slice(1);
    }

    if (path[path.length - 1] !== "/") {
      path += "/";
    }

    return path;
  };

  _detectUserBrowser = () => {
    if (navigator.userAgent.indexOf("Chrome") >= 0) {
      return document.querySelector("html").scrollTop;
    }

    if (navigator.userAgent.indexOf("Safari") >= 0) {
      return document.body.scrollTop;
    }

    if (
      navigator.userAgent.indexOf("Firefox") >= 0 ||
      navigator.userAgent.indexOf("IE") >= 0
    ) {
      return document.documentElement.scrollTop;
    }

    return document.querySelector("html").scrollTop;
  };

  _onScroll = e => {
    const breakpoint = 600;
    let scrollTop = this._detectUserBrowser();

    if (scrollTop > breakpoint) {
      if (!this.passBreakpoint) {
        this.passBreakpoint = true;
        this.forceUpdate();
      }
    } else {
      if (this.passBreakpoint) {
        this.passBreakpoint = false;
        this.forceUpdate();
      }
    }
  };

  _isNavbarTransparentInPage = () => {
    let {
      location: { pathname }
    } = this.props;
    pathname = this._normalizePath(pathname);

    return false;
  };

  _isFooterDisplayNoneInPage = () => {
    let {
      location: { pathname }
    } = this.props;
    pathname = this._normalizePath(pathname);

    if (pathname === "/cart/") {
      return true;
    }

    return false;
  };

  _sendGAScrollTrackingIfNeed = percentage => {
    try {
      const INTERVAL = 20;
      let currentScrollPosition =
        Math.floor((percentage * 100) / INTERVAL) * INTERVAL;

      let shouldReportToGA = (function isScrollDown(_new, _old) {
        return (
          _new !== _old &&
          (_new > 0 || (_old === -1 && _new === 0)) &&
          _new > _old
        );
      })(currentScrollPosition, this._lastScrollPosition);

      if (shouldReportToGA) {
        console.log(
          "scroll position Change",
          this._lastScrollPosition,
          " -> ",
          currentScrollPosition,
          " ",
          this._lastPathname
        );
        this._lastScrollPosition = currentScrollPosition;
        GA.customEvent(
          "Scroll",
          "percent" + currentScrollPosition,
          this._lastPathname
        );
      }
    } catch (e) {
      console.warn("get percentage error", e);
    }
  };

  _dirtyHackForPathMonitor = () => {
    try {
      let { pathname, search } = this.props.location;
      if (pathname + search !== this._lastPathname) {
        this._lastScrollPosition = -1;
        this._lastPathname = pathname + search;
      }
    } catch (e) {
      console.warn(e);
    }
  };
}

Layout.Wrapper = styled.div`
  min-height: calc(100vh);
  background-color: white;
  padding-top: ${props =>
    props.withPaddingTop ? AppConfig.global.navbarHeight : 0}px;
  display: flex;
  flex-direction: column;
`;

Layout.Content = styled.div`
  flex: 1;
  align-self: stretch;
  display: flex;
  flex-direction: column;
`;

export default Layout;
